import React from "react";
import { MarketplaceFilterSettings } from "../MarketplaceFilterSettings";
import { useMarketplaceStore } from "../../../../store/useMarketplaceStore";

export const TargetMarketplaceFilterSettings = () => {
  const selectedCountry = useMarketplaceStore((state) => state.selectedCountry);

  const targetSettingsConfig = {
    baseSettings: [
      "fbaSellerBlocking",
      "amazonSbaSellerBlocking",
      "noSalesRankBlocking",
      "chineseSellerBlocking",
      "minSellerQuantityAction",
      "maxSellerQuantityAction",
      "restrictedProductAction",
    ],
    thresholdMapping: {
      minSellerQuantityAction: "minSellerQuantityThreshold",
      maxSellerQuantityAction: "maxSellerQuantityThreshold",
    },
    defaultValues: {
      fbaSellerBlocking: "",
      amazonSbaSellerBlocking: "",
      noSalesRankBlocking: "",
      chineseSellerBlocking: "",
      minSellerQuantityAction: "",
      minSellerQuantityThreshold: 0,
      maxSellerQuantityAction: "",
      maxSellerQuantityThreshold: 0,
      restrictedProductAction: "",
    },
    allowedValuesMapping: {
      minSellerQuantityAction: ["ALLOW"],
      maxSellerQuantityAction: ["ALLOW"],
    },
    url: `store/${selectedCountry?.id}/target-marketplace-filter-settings`,
    translateKey: "targetMarketplaceFilterSettings",
  };

  if (!selectedCountry) {
    return null;
  }

  return <MarketplaceFilterSettings settingsConfig={targetSettingsConfig} />;
};
